export default class RouteData {
    constructor(tag, data, features, creationDate) {
        this.tag = tag,
            this.data = data,
            this.features = features,
            this.creationDate = creationDate
    }

    get startDate() {
        const firstPoint = this.data[0]
        return firstPoint.etd.substring(0, 8)
    }

    get endDate() {
        const lastPoint = this.data.slice(-1)[0]
        return lastPoint.etd.substring(0, 8)
    }
}